import React from 'react';
import VisionMission from '../components/sections/VisionMission';
import CoreValues from '../components/sections/CoreValues';
import Statistics from '../components/sections/Statistics';
import Testimonials from '../components/sections/Testimonials';

interface AboutProps {
  counters: {
    projects: number;
    satisfaction: number;
    years: number;
    support: number;
  };
}

const About: React.FC<AboutProps> = ({ counters }) => {
  return (
    <main className="pt-20 sm:pt-24">
      {/* Hero Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium text-gray-900 mb-4 sm:mb-6">
                About Curiye Advert
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                We are a creative agency that specializes in visual storytelling, brand identity, and event branding. 
                We offer strategic design solutions for businesses, organizations, and startups that want to build 
                strong, clear, and memorable brands.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-500 leading-relaxed">
                Our team combines creativity with strategy to deliver exceptional results that not only look great 
                but also drive business growth and create lasting connections with your audience.
              </p>
            </div>
            <div className="relative order-1 lg:order-2 mb-8 lg:mb-0">
              <div className="w-full h-64 sm:h-80 md:h-96 rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg">
                <img 
                  src="/images/about us.jpg" 
                  alt="About Curiye Advert - Our team working together" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium text-gray-900 mb-6 sm:mb-8">Our Story</h2>
            <div className="prose prose-sm sm:prose-base md:prose-lg mx-auto text-gray-600">
              <p className="text-base sm:text-lg md:text-xl leading-relaxed mb-4 sm:mb-6">
                Founded with a passion for creativity and a vision for excellence, Curiye Advert has been at the forefront 
                of brand transformation in Somalia and beyond. We believe that every business has a unique story to tell, 
                and our mission is to help you tell that story in the most compelling way possible.
              </p>
              <p className="text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6">
                Our journey began with a simple idea: to bridge the gap between traditional business practices and modern 
                digital innovation. We saw an opportunity to help local businesses compete on a global scale through 
                strategic branding and creative storytelling.
              </p>
              <p className="text-sm sm:text-base md:text-lg leading-relaxed">
                Today, we're proud to have worked with over 150+ businesses, helping them build stronger brands, 
                connect with their audiences, and achieve their business goals. Our team of creative professionals 
                brings together diverse skills and perspectives to deliver solutions that are both beautiful and effective.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Vision & Mission */}
      <VisionMission />

      {/* Core Values */}
      <CoreValues />

      {/* Statistics */}
      <Statistics counters={counters} />

      {/* Testimonials */}
      <Testimonials />
    </main>
  );
};

export default About;
